import type { RangeOption } from "../constants/epicLeaderboard";

const HOUR_MS = 60 * 60 * 1000;
const DAY_MS = 24 * HOUR_MS;

// ISO start date for a range option, or undefined for "all".
export const rangeToStartDate = (range: RangeOption): string | undefined => {
  // Rounded down to the hour so repeat requests share a URL and can hit the
  // API's cache instead of differing by milliseconds.
  const now = Math.floor(Date.now() / HOUR_MS) * HOUR_MS;
  switch (range) {
    case "7d":
      return new Date(now - 7 * DAY_MS).toISOString();
    case "30d":
      return new Date(now - 30 * DAY_MS).toISOString();
    case "90d":
      return new Date(now - 90 * DAY_MS).toISOString();
    case "year":
      return new Date(Date.UTC(new Date().getUTCFullYear(), 0, 1)).toISOString();
    case "all":
    default:
      return undefined;
  }
};
